import React, { useState } from 'react';

// Dummy data for various tabs
const dummyData = {
  new: [
    { id: 1, name: 'Hyundai Creta 2025', price: '₹11.00 Lakh', image: 'https://via.placeholder.com/300x200/1a1a1a/ffffff?text=Creta', mileage: '18 kmpl' },
    { id: 2, name: 'Tata Nexon', price: '₹8.00 Lakh', image: 'https://via.placeholder.com/300x200/1a1a1a/ffffff?text=Nexon', mileage: '20 kmpl' },
    { id: 3, name: 'Maruti Swift', price: '₹6.50 Lakh', image: 'https://via.placeholder.com/300x200/1a1a1a/ffffff?text=Swift', mileage: '22 kmpl' },
    { id: 4, name: 'Kia Seltos', price: '₹10.90 Lakh', image: 'https://via.placeholder.com/300x200/1a1a1a/ffffff?text=Seltos', mileage: '16 kmpl' },
    { id: 5, name: 'Mahindra XUV700', price: '₹14.00 Lakh', image: 'https://via.placeholder.com/300x200/1a1a1a/ffffff?text=XUV700', mileage: '15 kmpl' },
    { id: 6, name: 'Toyota Innova Crysta', price: '₹19.99 Lakh', image: 'https://via.placeholder.com/300x200/1a1a1a/ffffff?text=Innova', mileage: '14 kmpl' },
  ],
  used: [
    { id: 1, name: 'Used Honda City 2022', price: '₹7.50 Lakh', image: 'https://via.placeholder.com/300x200/2a2a2a/ffffff?text=Used+City', mileage: '17 kmpl', year: 2022 },
    { id: 2, name: 'Used Ford EcoSport 2019', price: '₹5.20 Lakh', image: 'https://via.placeholder.com/300x200/2a2a2a/ffffff?text=Used+EcoSport', mileage: '19 kmpl', year: 2019 },
    { id: 3, name: 'Used Volkswagen Polo 2021', price: '₹6.80 Lakh', image: 'https://via.placeholder.com/300x200/2a2a2a/ffffff?text=Used+Polo', mileage: '21 kmpl', year: 2021 },
  ],
  upcoming: [
    { id: 1, name: 'Tata Sierra Revival', price: '₹15.00 Lakh (est.)', image: 'https://via.placeholder.com/300x200/3a3a3a/ffffff?text=Sierra', launch: 'Q1 2026' },
    { id: 2, name: 'MG Cyberster EV', price: '₹50.00 Lakh (est.)', image: 'https://via.placeholder.com/300x200/3a3a3a/ffffff?text=Cyberster', launch: 'Q4 2025' },
    { id: 3, name: 'Hyundai Ioniq 6', price: '₹45.00 Lakh (est.)', image: 'https://via.placeholder.com/300x200/3a3a3a/ffffff?text=Ioniq+6', launch: 'Mid 2026' },
  ],
  ev: [
    { id: 1, name: 'MG ZS EV', price: '₹19.00 Lakh', image: 'https://via.placeholder.com/300x200/4a4a4a/ffffff?text=ZS+EV', range: '461 km' },
    { id: 2, name: 'Tata Nexon EV', price: '₹14.50 Lakh', image: 'https://via.placeholder.com/300x200/4a4a4a/ffffff?text=Nexon+EV', range: '465 km' },
    { id: 3, name: 'Hyundai Kona Electric', price: '₹23.84 Lakh', image: 'https://via.placeholder.com/300x200/4a4a4a/ffffff?text=Kona+EV', range: '452 km' },
    { id: 4, name: 'BYD Atto 3', price: '₹33.99 Lakh', image: 'https://via.placeholder.com/300x200/4a4a4a/ffffff?text=Atto+3', range: '521 km' },
  ],
  mechanics: [
    { id: 1, name: 'AutoFix Garage', location: 'Delhi NCR', rating: 4.8, services: 'Engine Repair, Brake Service' },
    { id: 2, name: 'Speedy Mechanics', location: 'Mumbai', rating: 4.5, services: 'Transmission Overhaul, AC Repair' },
    { id: 3, name: 'Elite Auto Care', location: 'Bangalore', rating: 4.9, services: 'Suspension Work, Electrical Diagnostics' },
  ],
  'service-center': [
    { id: 1, name: 'Maruti Authorized Service', location: 'New Delhi', rating: 4.7, contact: '+91-11-XXXXXXX' },
    { id: 2, name: 'Hyundai Service Hub', location: 'Mumbai', rating: 4.6, contact: '+91-22-XXXXXXX' },
    { id: 3, name: 'Tata Motors Center', location: 'Pune', rating: 4.8, contact: '+91-20-XXXXXXX' },
  ],
  'spare-parts': [
    { id: 1, name: 'Brake Pads (Hyundai)', price: '₹2,500', image: 'https://via.placeholder.com/150x150/5a5a5a/ffffff?text=Brake+Pads' },
    { id: 2, name: 'Oil Filter (Maruti)', price: '₹800', image: 'https://via.placeholder.com/150x150/5a5a5a/ffffff?text=Oil+Filter' },
    { id: 3, name: 'Tyres (Michelin 205/55 R16)', price: '₹8,000', image: 'https://via.placeholder.com/150x150/5a5a5a/ffffff?text=Tyres' },
    { id: 4, name: 'Battery (12V)', price: '₹4,200', image: 'https://via.placeholder.com/150x150/5a5a5a/ffffff?text=Battery' },
  ],
  'car-cleaning': [
    { id: 1, name: 'Premium Exterior Wash', price: '₹500', duration: '30 min', description: 'Full body wash with wax' },
    { id: 2, name: 'Interior Deep Clean', price: '₹1,200', duration: '2 hours', description: 'Vacuum, steam clean seats' },
    { id: 3, name: 'Complete Detailing Package', price: '₹2,500', duration: '4 hours', description: 'Exterior + Interior + Polish' },
  ],
  // Additional aspects apart from CarDekho (e.g., no comparisons, reviews, garage, stories, insurance/finance, accessories here)
  news: [
    { id: 1, title: 'Auto Expo 2026 Highlights', date: 'Oct 23, 2025', excerpt: 'New EVs and SUVs unveiled...' },
    { id: 2, title: 'Fuel Price Hike Impact', date: 'Oct 22, 2025', excerpt: 'How it affects car buyers...' },
    { id: 3, title: 'Best Winter Tyres Guide', date: 'Oct 20, 2025', excerpt: 'Top picks for safety...' },
  ],
  forums: [
    { id: 1, title: 'Best SUV under 15L?', replies: 45, views: 1200 },
    { id: 2, name: 'EV Charging Issues', replies: 32, views: 890 },
    { id: 3, name: 'Maintenance Tips for Diesel', replies: 28, views: 650 },
  ],
  'test-drives': [
    { id: 1, model: 'Mahindra Thar', location: 'Delhi', date: 'Available Now', duration: '30 min' },
    { id: 2, model: 'Skoda Slavia', location: 'Mumbai', date: 'Book for Weekend', duration: '45 min' },
    { id: 3, model: 'Kia EV6', location: 'Bangalore', date: 'Oct 25, 2025', duration: '1 hour' },
  ],
  'dealer-locator': [
    { id: 1, name: 'ABC Motors Delhi', address: 'Connaught Place, New Delhi', brands: 'Hyundai, Kia' },
    { id: 2, name: 'XYZ Auto Mumbai', address: 'Bandra Kurla Complex, Mumbai', brands: 'Tata, MG' },
    { id: 3, name: 'PQR Dealers Bangalore', address: 'MG Road, Bangalore', brands: 'Maruti, Toyota' },
  ],
  events: [
    { id: 1, name: 'Car Show 2025', date: 'Nov 15-17', location: 'Pragati Maidan, Delhi', description: 'Auto exhibition with test drives' },
    { id: 2, name: 'EV Rally', date: 'Dec 5', location: 'Mumbai to Goa', description: 'Electric vehicle adventure event' },
  ],
  community: [
    { id: 1, name: 'Car Enthusiasts Club Delhi', members: 500, activities: 'Meets, Drives' },
    { id: 2, name: 'Women in Autos Group', members: 250, activities: 'Workshops, Networking' },
    { id: 3, name: 'Vintage Car Lovers', members: 300, activities: 'Restoration, Shows' },
  ],
};

const CarDreamHome = () => {
  const [activeTab, setActiveTab] = useState('new');

  const renderTabContent = (tab) => {
    const data = dummyData[tab] || [];
    switch (tab) {
      case 'new':
      case 'used':
      case 'upcoming':
      case 'ev':
        return (
          <div className="grid grid-cols-1 text-xs lg:text-lg sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 text-xs rounded-lg overflow-hidden shadow-lg">
                <img src={item.image} alt={item.name} className="w-full h-48 object-cover" />
                <div className="p-4">
                  <h3 className="text-white font-semibold text-lg">{item.name}</h3>
                  <p className="text-green-400 font-bold">{item.price}</p>
                  {item.mileage && <p className="text-gray-300">Mileage: {item.mileage}</p>}
                  {item.range && <p className="text-gray-300">Range: {item.range}</p>}
                  {item.year && <p className="text-gray-300">Year: {item.year}</p>}
                  {item.launch && <p className="text-gray-300">Launch: {item.launch}</p>}
                </div>
              </div>
            ))}
          </div>
        );
      case 'mechanics':
      case 'service-center':
        return (
          <div className="space-y-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg p-4 shadow-md">
                <h3 className="text-white font-semibold">{item.name}</h3>
                <p className="text-gray-300">{item.location}</p>
                <p className="text-yellow-400">Rating: {item.rating}/5</p>
                <p className="text-gray-400">{item.services || item.contact}</p>
              </div>
            ))}
          </div>
        );
      case 'spare-parts':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg overflow-hidden shadow-lg">
                <img src={item.image} alt={item.name} className="w-full h-32 object-cover" />
                <div className="p-3">
                  <h3 className="text-white text-sm font-medium">{item.name}</h3>
                  <p className="text-green-400 font-bold">₹{item.price}</p>
                </div>
              </div>
            ))}
          </div>
        );
      case 'car-cleaning':
        return (
          <div className="space-y-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg p-4 shadow-md">
                <h3 className="text-white font-semibold">{item.name}</h3>
                <p className="text-green-400 font-bold">₹{item.price}</p>
                <p className="text-gray-300">Duration: {item.duration}</p>
                <p className="text-gray-400">{item.description}</p>
              </div>
            ))}
          </div>
        );
      case 'news':
        return (
          <div className="space-y-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg p-4 shadow-md">
                <h3 className="text-white font-semibold">{item.title}</h3>
                <p className="text-gray-300 text-sm">{item.date}</p>
                <p className="text-gray-400">{item.excerpt}</p>
              </div>
            ))}
          </div>
        );
      case 'forums':
        return (
          <div className="space-y-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg p-4 shadow-md">
                <h3 className="text-white font-semibold">{item.name || item.title}</h3>
                <p className="text-gray-300">Replies: {item.replies} | Views: {item.views}</p>
              </div>
            ))}
          </div>
        );
      case 'test-drives':
        return (
          <div className="space-y-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg p-4 shadow-md">
                <h3 className="text-white font-semibold">{item.model}</h3>
                <p className="text-gray-300">Location: {item.location}</p>
                <p className="text-gray-300">Date: {item.date}</p>
                <p className="text-gray-400">Duration: {item.duration}</p>
              </div>
            ))}
          </div>
        );
      case 'dealer-locator':
        return (
          <div className="space-y-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg p-4 shadow-md">
                <h3 className="text-white font-semibold">{item.name}</h3>
                <p className="text-gray-300">{item.address}</p>
                <p className="text-gray-400">Brands: {item.brands}</p>
              </div>
            ))}
          </div>
        );
      case 'events':
        return (
          <div className="space-y-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg p-4 shadow-md">
                <h3 className="text-white font-semibold">{item.name}</h3>
                <p className="text-gray-300">Date: {item.date}</p>
                <p className="text-gray-300">Location: {item.location}</p>
                <p className="text-gray-400">{item.description}</p>
              </div>
            ))}
          </div>
        );
      case 'community':
        return (
          <div className="space-y-4">
            {data.map((item) => (
              <div key={item.id} className="bg-gray-800 rounded-lg p-4 shadow-md">
                <h3 className="text-white font-semibold">{item.name}</h3>
                <p className="text-gray-300">Members: {item.members}</p>
                <p className="text-gray-400">Activities: {item.activities}</p>
              </div>
            ))}
          </div>
        );
      default:
        return <p className="text-gray-300 text-center py-8">Content for {tab} coming soon!</p>;
    }
  };

  const tabLabels = {
    new: { label: 'New Cars', emoji: '🚗' },
    used: { label: 'Used Cars', emoji: '🚙' },
    upcoming: { label: 'Upcoming', emoji: '🆕' },
    ev: { label: 'Electric Vehicles', emoji: '⚡' },
    mechanics: { label: 'Mechanics', emoji: '🧰' },
    'service-center': { label: 'Service Centers', emoji: '🛠️' },
    'spare-parts': { label: 'Spare Parts', emoji: '🔩' },
    'car-cleaning': { label: 'Car Cleaning', emoji: '🧽' },
    news: { label: 'Car News', emoji: '📰' },
    forums: { label: 'Forums', emoji: '💬' },
    'test-drives': { label: 'Test Drives', emoji: '🏁' },
    'dealer-locator': { label: 'Dealers', emoji: '📍' },
    events: { label: 'Events', emoji: '🎪' },
    community: { label: 'Community', emoji: '🌐' },
  };


  return (
    <div className="min-h-screen bg-black text-white p-2">
      {/* Header */}
      <header className="text-center mb-2">
        <h1 className="text-xl lg:text-2xl font-bold text-yellow-200 mb-2">🚗 CarDream</h1>
        <p className="text-gray-300">Your Ultimate Car Hub</p>
      </header>

      {/* Tabs Navigation - Mobile first, 3 per row on small screens */}
      <nav className="grid grid-cols-2 lg:grid-cols-8 gap-1 mb-2 pb-21border-b border-gray-700 sm:grid-cols-auto place-items-center">
        {Object.keys(tabLabels).map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-2 py-2 text-xs rounded-t-lg whitespace-nowrap transition-colors text-center ${
              activeTab === tab
                ? 'bg-blue-600 text-white border-b-2 border-blue-400'
                : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
            }`}
          >
            <span className="mr-2">{tabLabels[tab].emoji}</span>
            {tabLabels[tab].label}
          </button>
        ))}
      </nav>


      {/* Tab Content */}
      <main className="mx-auto">
        {renderTabContent(activeTab)}
      </main>

      {/* Footer */}
      <footer className="mt-12 text-center text-gray-500 text-sm pt-8 border-t border-gray-700">
        <p>© 2025 Think5Whys Global DeepTech Solutions.</p>
      </footer>
    </div>
  );
};

export default CarDreamHome;